import styles from './styles/SelectedFlters.module.scss';
import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useAlgoliaAppContext } from '../../hooks/useAlgoliaAppContext';
import { MEDIA_BREAKPOINTS } from '../../../constants/MEDIA_BREAKPOINTS';
import { SEARCH_PARAM_KEY_PAGE_NUMBER, SEARCH_PARAM_KEY_TYPE } from '../../constants/searchParamKeys';
import { FACET_KEY_PIECES } from '../../constants/facetKeys';
import { Ssvg } from '../../../Components/react/Ssvg';
import { activeFacetConfigs, showFilterByTypes } from '../../configs';
import { clsx } from '../../../utils/clsx';
import { createPortal } from 'react-dom';
const helpButton = document.querySelector('fixed-help-component');
const Item = ({ label, onClick }) => (React.createElement("li", { className: styles.itemWrapper },
    React.createElement("button", { className: `btn:cleared bdrs:1 d:flex ai:center text:uppercase ${styles.item}`, onClick: onClick },
        React.createElement("span", null, label.includes('>') ? label.substring(label.lastIndexOf('>') + 2) : label),
        React.createElement(Ssvg, { icon: "#icon--clear-x", className: styles.itemIcon }))));
export const SelectedFilters = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { handle, medium } = useParams();
    const { pagePath } = useAlgoliaAppContext();
    const navigate = useNavigate();
    const items = [];
    const isMobile = !MEDIA_BREAKPOINTS.MD_UP.matches;
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    if (!isMobile && showFilterByTypes) {
        const value = searchParams.get(SEARCH_PARAM_KEY_TYPE);
        if (value !== null) {
            items.push(React.createElement(Item, { key: value, label: value, onClick: () => {
                    searchParams.delete(SEARCH_PARAM_KEY_TYPE);
                    setSearchParams(searchParams);
                } }));
        }
    }
    if (medium !== undefined) {
        items.push(React.createElement(Item, { key: medium, label: medium, onClick: () => {
                const searchStr = searchParams.toString();
                let pathname = `/${pagePath}`;
                if (handle !== undefined) {
                    pathname += `/${handle}`;
                }
                navigate({
                    pathname,
                    ...(searchStr.length > 0 && { search: `?${searchStr}` })
                });
            } }));
    }
    activeFacetConfigs.forEach(({ key, hierarchy }) => {
        if (hierarchy === undefined) {
            const values = searchParams.get(key)?.split(',');
            if (values !== undefined) {
                values.forEach(value => {
                    items.push(React.createElement(Item, { key: value, label: key === FACET_KEY_PIECES ? `${value} Piece${value === '1' ? '' : 's'}` : value, onClick: () => {
                            searchParams.delete(key);
                            const filteredValues = values.filter(v => v !== value);
                            if (filteredValues.length > 0) {
                                searchParams.set(key, filteredValues.join(','));
                            }
                            searchParams.sort();
                            setSearchParams(searchParams);
                        } }));
                });
            }
        }
        else {
            for (let i = 1; i <= hierarchy; i++) {
                const hKey = `${key}_lv${i}`;
                const values = searchParams.get(hKey)?.split(',');
                if (values !== undefined) {
                    values.forEach(value => {
                        items.push(React.createElement(Item, { key: value, label: value, onClick: () => {
                                searchParams.delete(hKey);
                                const filteredValues = values.filter(v => v !== value);
                                if (filteredValues.length > 0) {
                                    searchParams.set(hKey, filteredValues.join(','));
                                }
                                searchParams.sort();
                                setSearchParams(searchParams);
                            } }));
                    });
                }
            }
        }
    });
    useEffect(() => {
        if (items.length > 0) {
            helpButton?.classList.add(styles.fhButtonPosition);
        }
        else {
            helpButton?.classList.remove(styles.fhButtonPosition);
        }
    }, [items]);
    if (items.length < 1) {
        return null;
    }
    const content = (React.createElement("ul", { className: clsx('list:none scrbar:none ov:y:h ov:x:a d:inline-flex fxw:wrap:xl-up fx:1 text:nowrap', isMobile && 'pos:f l:0 w:100 bxsh:3', isMobile ? styles.wrapperMobile : styles.wrapper) }, items));
    return isMobile
        ? createPortal(content, document.body)
        : content;
};
